import React from 'react';
export function LoadingSpinner() {
  return <div className="flex items-center justify-center" data-id="element-128">
      <div className="relative w-16 h-16" data-id="element-129">
        <div className="absolute inset-0 rounded-full border-4 border-[#7FDBFF] opacity-25" data-id="element-130"></div>
        <div className="absolute inset-0 rounded-full border-4 border-[#2D7FF9] border-t-transparent animate-spin" data-id="element-131"></div>
      </div>
    </div>;
}